var __jsx = React.createElement;
import React from "react";
import MuscleTooltip from "../tooltip";
import { cn } from "@lib/cn";
import Icons from "../../../icons";
import useCssModules from "@lib/hooks/use-css-modules";
const Disclaimer = _ref => {
  let {
    text,
    message,
    tooltipPlacement = 'bottom',
    showIcon = true,
    iconPosition = 'right',
    toolTipMaxWidth = 238,
    toolTipPadding,
    onClick,
    customIconClassName,
    customTextClassName,
    customContainerStyle,
    tooltipBackgroundColor
  } = _ref;
  const {
    cssModules
  } = useCssModules();
  const content = __jsx("div", {
    className: cn("flex mr-3 w-fit items-center", {
      "flex-row": iconPosition === "left",
      "flex-row-reverse": iconPosition === "right"
    })
  }, showIcon ? __jsx(Icons.info, {
    className: customIconClassName || (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.disclaimer.iconClassName)
  }) : null, __jsx("p", {
    className: cn(customTextClassName || (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.disclaimer.textClassName), {
      "ml-2": iconPosition === "left",
      "mr-2": iconPosition === "right"
    })
  }, text));
  return __jsx("div", {
    className: cn(customContainerStyle),
    onClick: onClick
  }, message ? __jsx(MuscleTooltip, {
    text: message,
    placement: tooltipPlacement,
    maxWidth: toolTipMaxWidth,
    padding: toolTipPadding,
    backgroundColor: tooltipBackgroundColor || (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.disclaimer.backgroundColor)
  }, content) : content);
};
export default Disclaimer;